import styled, { css } from 'styled-components';

export const SubscriptionCardWrapper = styled.div<{ $selected?: boolean }>`
  display: flex;
  min-width: 437px;
  width: 100%;
  min-height: 244px;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  border-radius: 16px;
  cursor: pointer;
  border: 1px solid
    ${({ $selected, theme }) => ($selected ? theme.colors.green4 : theme.colors.black4)};
  background: ${({ $selected, theme }) => ($selected ? theme.colors.green1 : theme.colors.white)};
  transition: all 0.3s ease;
  &:hover {
    ${({ $selected }) =>
      $selected
        ? css`
            border: 2px solid ${({ theme }) => theme.colors.green4};
          `
        : css`
            background: ${({ theme }) => theme.colors.black2};
          `}
  }
`;

export const CourseInfoWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  margin-top: auto;
`;

export const CourseName = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  align-self: stretch;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const CourseProgressWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const ProgressBarWrapper = styled.div`
  width: 100%;
`;
export const EmojiWrapper = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.colors.black1};
  padding: 8px;
  border-radius: 16px;
  width: 64px;
  height: 64px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  aspect-ratio: 1/1;
  font-size: 38px;
  font-weight: 600;
  line-height: 46px;
`;

export const ProgressText = styled.span<{ $isProgressStarted: boolean }>`
  color: ${({ theme, $isProgressStarted }) =>
    $isProgressStarted ? theme.colors.green7 : theme.colors.black9};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
`;
